import {useEffect} from 'react'
import {backendRequest} from '../../../common/utils/requests'

/**
 * Records that the viewer landed on a PAMM offer page so the dashboard's
 * floating "Pending PAMM Offers" block (PT-5354) can show the offer if the
 * user navigates away without accepting or dismissing it. Best-effort —
 * failures are swallowed because they shouldn't block the offer page itself.
 */
export const useRecordVisit = ({managerId, offerId}: {managerId: number; offerId: number}) => {
  useEffect(() => {
    if (!managerId || !offerId) return
    backendRequest(`/api/v2/dashboard/pamm/managers/${managerId}/offers/${offerId}/visit`, {}).catch(
      // eslint-disable-next-line no-console
      (error) => console.error('Failed to record PAMM offer visit', error),
    )
  }, [managerId, offerId])
}
